(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter((element) => {
      const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
      return (
        element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
        !(event.target instanceof Node && element.contains(event.target))
      );
    });

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

(function elagiliProductPagePolish() {
  if (!window.location.pathname.includes('/products/')) return;

  function cleanJudgeMeEmptyState() {
    document.querySelectorAll('.jdgm-widget, .jdgm-review-widget, [class*="jdgm-"]').forEach((root) => {
      root.querySelectorAll('div,span,p').forEach((element) => {
        if (element.children.length === 0 && element.textContent && element.textContent.trim() === 'No items found') {
          element.hidden = true;
          element.setAttribute('aria-hidden', 'true');
        }
      });
    });
  }

  function runBoundedJudgeMeCleanup() {
    cleanJudgeMeEmptyState();
    [800, 2200].forEach((delay) => window.setTimeout(cleanJudgeMeEmptyState, delay));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runBoundedJudgeMeCleanup, { once: true });
  } else {
    runBoundedJudgeMeCleanup();
  }

  document.addEventListener('shopify:section:load', runBoundedJudgeMeCleanup);
})();

(function elagiliMobileStickyAddToCart() {
  if (!window.location.pathname.includes('/products/')) return;

  let originalButton = null;
  let stickyBar = null;
  let stickyButton = null;
  let buttonObserver = null;

  function addStyles() {
    if (document.getElementById('elagili-sticky-atc-styles')) return;
    const style = document.createElement('style');
    style.id = 'elagili-sticky-atc-styles';
    style.textContent = `
      .elagili-sticky-atc { display: none; }
      @media (max-width: 749px) {
        .elagili-sticky-atc {
          position: fixed;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 35;
          padding: 10px 14px calc(10px + env(safe-area-inset-bottom));
          background: var(--color-background, #fff);
          border-top: 1px solid var(--color-border, rgba(0,0,0,.12));
          box-shadow: 0 -8px 24px rgba(0,0,0,.10);
          transform: translateY(110%);
          opacity: 0;
          pointer-events: none;
          transition: transform .2s ease, opacity .2s ease;
        }
        .elagili-sticky-atc.is-visible {
          display: block;
          transform: translateY(0);
          opacity: 1;
          pointer-events: auto;
        }
        .elagili-sticky-atc__button {
          width: 100%;
          min-height: 48px;
          margin: 0;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        .elagili-sticky-atc { transition: none !important; }
      }
    `;
    document.head.appendChild(style);
  }

  function findOriginalButton() {
    return document.querySelector(
      '.product-information product-form-component .add-to-cart-button, .product-information .add-to-cart-button'
    );
  }

  function ensureStickyBar() {
    if (stickyBar) return;
    stickyBar = document.createElement('div');
    stickyBar.className = 'elagili-sticky-atc';
    stickyBar.setAttribute('aria-hidden', 'true');

    stickyButton = document.createElement('button');
    stickyButton.type = 'button';
    stickyButton.className = 'button elagili-sticky-atc__button';
    stickyButton.textContent = 'Add to cart';
    stickyButton.addEventListener('click', function () {
      const currentButton = findOriginalButton();
      if (currentButton && !currentButton.disabled) currentButton.click();
    });

    stickyBar.appendChild(stickyButton);
    document.body.appendChild(stickyBar);
  }

  function syncStickyButton() {
    const nextButton = findOriginalButton();
    if (!nextButton) {
      if (stickyBar) stickyBar.classList.remove('is-visible');
      return;
    }

    if (nextButton !== originalButton) {
      originalButton = nextButton;
      if (buttonObserver) buttonObserver.disconnect();
      buttonObserver = new MutationObserver(function () {
        syncStickyButton();
        updateVisibility();
      });
      buttonObserver.observe(originalButton, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    ensureStickyBar();
    const label = (originalButton.textContent || '').replace(/\s+/g, ' ').trim();
    stickyButton.textContent = label || 'Add to cart';
    stickyButton.disabled = !!originalButton.disabled || originalButton.getAttribute('aria-disabled') === 'true';
  }

  function updateVisibility() {
    if (!stickyBar || !originalButton || window.innerWidth >= 750) {
      if (stickyBar) {
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      }
      return;
    }

    const rect = originalButton.getBoundingClientRect();
    const originalVisible = rect.bottom > 0 && rect.top < window.innerHeight;
    const shouldShow = !originalVisible && window.scrollY > 160;
    stickyBar.classList.toggle('is-visible', shouldShow);
    stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
  }

  function initialise() {
    addStyles();
    syncStickyButton();
    updateVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  let scrollFrame = 0;
  function scheduleVisibilityUpdate() {
    if (scrollFrame) return;
    scrollFrame = window.requestAnimationFrame(function () {
      scrollFrame = 0;
      updateVisibility();
    });
  }

  window.addEventListener('scroll', scheduleVisibilityUpdate, { passive: true });
  window.addEventListener('resize', scheduleVisibilityUpdate, { passive: true });
  document.addEventListener('change', function () {
    window.setTimeout(function () {
      syncStickyButton();
      updateVisibility();
    }, 80);
  });
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(initialise, 80);
  });
})();

(function elagiliMobileCollectionControls() {
  const isCollectionOrSearch = window.location.pathname.includes('/collections/') || window.location.pathname === '/search';
  if (!isCollectionOrSearch) return;

  function addStyles() {
    if (document.getElementById('elagili-mobile-facets-styles')) return;
    const style = document.createElement('style');
    style.id = 'elagili-mobile-facets-styles';
    style.textContent = `
      @media (max-width: 749px) {
        .facets-toggle__wrapper { width: 100%; }
        .facets-toggle__button {
          min-height: 44px;
          padding: 9px 12px !important;
          border: 1px solid #E4E8EC !important;
          border-radius: 6px;
          width: 100%;
          justify-content: flex-start;
          gap: 8px;
          background: #fff;
          color: #1F2933;
        }
        .facets-toggle__button .elagili-filter-sort-label { font-weight: 600; }
        .facets-toggle__button .elagili-mobile-result-count {
          margin-left: auto;
          color: #66727D;
          font-size: .82rem;
          font-weight: 400;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function polishControls() {
    addStyles();

    document.querySelectorAll('.facets-toggle__button').forEach((button) => {
      Array.from(button.childNodes).forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) node.textContent = '';
      });

      let label = button.querySelector('.elagili-filter-sort-label');
      if (!label) {
        label = document.createElement('span');
        label.className = 'elagili-filter-sort-label';
        label.textContent = 'Filter & sort';
        const icon = button.querySelector('.svg-wrapper');
        if (icon) icon.insertAdjacentElement('afterend', label);
        else button.prepend(label);
      }

      const countSource = document.querySelector('.facets--horizontal .products-count-wrapper span');
      let count = button.querySelector('.elagili-mobile-result-count');
      if (!count) {
        count = document.createElement('span');
        count.className = 'elagili-mobile-result-count';
        count.setAttribute('aria-live', 'polite');
        button.appendChild(count);
      }

      const countText = countSource ? countSource.textContent.replace(/\s+/g, ' ').trim() : '';
      if (count.textContent !== countText) count.textContent = countText;
      count.hidden = !countText;
    });

    document.querySelectorAll('.facets-drawer__title').forEach((title) => {
      Array.from(title.childNodes).forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) node.textContent = '';
      });
      if (!title.querySelector('.elagili-drawer-filter-title')) {
        const text = document.createElement('span');
        text.className = 'elagili-drawer-filter-title';
        text.textContent = 'Filter & sort';
        title.prepend(text);
      }
    });
  }

  let scheduled = false;
  function schedulePolish() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      polishControls();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', polishControls, { once: true });
  } else {
    polishControls();
  }

  const root = document.querySelector('results-list');
  if (root) {
    const observer = new MutationObserver(schedulePolish);
    observer.observe(root, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', schedulePolish);
})();

(function elagiliEmptyCartJourney() {
  function addStyles() {
    if (document.getElementById('elagili-empty-cart-styles')) return;
    const style = document.createElement('style');
    style.id = 'elagili-empty-cart-styles';
    style.textContent = `
      .elagili-empty-cart-help {
        width: 100%;
        max-width: 420px;
        margin-top: 16px;
        display: grid;
        gap: 14px;
      }
      .elagili-empty-cart-trust {
        margin: 0;
        color: #66727D;
        font-size: .82rem;
        line-height: 1.5;
        text-align: center;
      }
      .elagili-empty-cart-links {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 8px;
      }
      .elagili-empty-cart-links a {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 40px;
        padding: 8px 10px;
        border: 1px solid #E4E8EC;
        border-radius: 6px;
        color: #354557;
        background: #fff;
        text-decoration: none;
        text-align: center;
        font-size: .78rem;
        font-weight: 600;
        line-height: 1.25;
      }
      .elagili-empty-cart-links a:hover,
      .elagili-empty-cart-links a:focus-visible { border-color: #354557; }
      @media (max-width: 390px) {
        .elagili-empty-cart-links { grid-template-columns: 1fr; }
      }
    `;
    document.head.appendChild(style);
  }

  function polishEmptyCart(root) {
    const scope = root || document;
    const emptyButtons = scope.querySelectorAll ? scope.querySelectorAll('.cart-items__empty-button') : [];
    if (!emptyButtons.length) return;
    addStyles();

    emptyButtons.forEach((button) => {
      button.textContent = 'Shop available products';
      button.setAttribute('href', '/#shopify-section-elagili_available_now');

      const wrapper = button.closest('.cart-items__wrapper');
      if (!wrapper || wrapper.querySelector('.elagili-empty-cart-help')) return;

      const help = document.createElement('div');
      help.className = 'elagili-empty-cart-help';
      help.innerHTML = `
        <p class="elagili-empty-cart-trust">Free standard UK delivery over £75 · 30-day returns · Secure checkout</p>
        <nav class="elagili-empty-cart-links" aria-label="Popular shopping categories">
          <a href="/collections/home-tech">Home &amp; Appliances</a>
          <a href="/collections/all-beauty">Beauty</a>
          <a href="/collections/food">Food &amp; Drink</a>
        </nav>
      `;
      button.insertAdjacentElement('afterend', help);
    });
  }

  function observeCartRoot(root) {
    if (!root || root.dataset.elagiliEmptyCartObserved === 'true') return;
    root.dataset.elagiliEmptyCartObserved = 'true';
    polishEmptyCart(root);
    const observer = new MutationObserver(function () {
      window.requestAnimationFrame(function () {
        polishEmptyCart(root);
      });
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function initialise() {
    document.querySelectorAll('cart-items-component').forEach(observeCartRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
  document.addEventListener('shopify:section:load', initialise);
})();
